export const VEHICLE_URL =
  'https://raw.githubusercontent.com/cartrawler/mobility-react-native-assessment/master/assets/availability.json';

export const PRODUCT_TYPES = {
  STANDARD: 'STANDARD',
  OTHER: 'OTHER',
};

export const VEHICLE_TYPES = {
  SEDAN: 'SEDAN',
  SUV: 'SUV',
  ECO: 'ECO',
  MINIBUS: 'MINIBUS',
  ACCESSIBLE: 'ACCESSIBLE',
};

export const VEHICLE_TABLE_KEYS = {
  ETA: 'eta',
  SUPPLIER: 'supplier',
  PRICE: 'price',
  CATEGORY: 'productType',
  VEHICLE_TYPE: 'vehicleType',
};
